module.exports = __webpack_public_path__ + "assets/close-red-2f8ac9.svg";